import type { IconName } from "@-/dev.improve.haniverse.components.ui.icon";

/** Which side of a morpheme the card drills. */
export type CardTileType =
  | "meaning"
  | "pronunciation"
  | "sentence-glyphs"
  | "sentence-speech"
  | "word-sentence";

/** Human-readable label, kept for accessibility (the tile now shows an icon, not text). */
export const CARD_TILE_TYPE_LABELS: Record<CardTileType, string> = {
  meaning: "Meaning",
  pronunciation: "Pronunciation",
  "sentence-glyphs": "Sentence writing",
  "sentence-speech": "Sentence speaking",
  "word-sentence": "Word",
};

/**
 * Corner icon shown in the top-left of each card tile in place of the card-type
 * label: a book for the meaning side, a "speaking" glyph for the pronunciation side.
 */
export const CARD_TILE_TYPE_ICONS: Record<CardTileType, IconName> = {
  meaning: "IoMdBook",
  pronunciation: "RiSpeakLine",
  // The two sentence-production drills take the input they are answered with — a keyboard for
  // writing, a mic for speaking — so a deck tile says at a glance which one it is. Reusing the
  // message icon for all three would make the three cards of one word indistinguishable.
  "sentence-glyphs": "TbKeyboard",
  "sentence-speech": "LuMic",
  // A word card is drilled in a sentence, so it takes the sentence/message icon the sentences
  // info tab already uses.
  "word-sentence": "LuMessageSquare",
};
